import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-language',
  template: `
    <select #langSelect (change)="translate.use(langSelect.value)">
      <option
        *ngFor="let lang of translate.getLangs()"
        [value]="lang"
        [attr.selected]="lang === translate.currentLang ? '' : null">
        {{lang|uppercase}}
      </option>
    </select>
    `,
})

export class SelectLanguageComponent {  
  constructor(public translate: TranslateService) { }
}